var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
var BackgroundImage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-image: url(\"", "\");\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 100%;\n  width: 100%;\n"], ["\n  background-image: url(\"", "\");\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 100%;\n  width: 100%;\n"])), function (props) { return props.url; });
/** @component */
export default BackgroundImage;
var templateObject_1;
